function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ListView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34",
    height: "34",
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M25.8 14.167H8.2c-1.458 0-2.64 1.108-2.64 2.475s1.182 2.475 2.64 2.475h17.6c1.458 0 2.64-1.108 2.64-2.475s-1.182-2.475-2.64-2.475ZM25.8 5.525H8.2C6.742 5.525 5.56 6.633 5.56 8s1.182 2.475 2.64 2.475h17.6c1.458 0 2.64-1.108 2.64-2.475s-1.182-2.475-2.64-2.475ZM25.8 22.81H8.2c-1.458 0-2.64 1.108-2.64 2.475 0 1.366 1.182 2.475 2.64 2.475h17.6c1.458 0 2.64-1.109 2.64-2.475 0-1.367-1.182-2.475-2.64-2.475Z",
    fill: "#BFF6F8",
    stroke: "#528693"
  }));
}

export default ListView;